module.exports = __webpack_public_path__ + "assets/img/wwt2.edaf7846.png";